import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-backbone', 'BrandBackbone', [["path",{"d":"M5 20l14 -8l-14 -8l0 16"}],["path",{"d":"M19 20l-14 -8l14 -8l0 16"}]]);